module.exports = __webpack_public_path__ + "static/media/logo-vegan.8a013d77.png";


//////////////////
// WEBPACK FOOTER
// ./src/pictures/logo-vegan.png
// module id = 113
// module chunks = 0